import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const OptionsContainer = styled.div<{ isUpsellSimplified: boolean }>`
  margin-block-end: ${primitive.$spacing1};
  li > *:first-child {
    padding-inline-start: 0;
    margin-inline-start: ${primitive.$spacing4};
    border-block-end: ${p => p.theme.token('border-default')};
  }

  li:last-of-type > *:first-child {
    border-block-end: ${props => !props.isUpsellSimplified && 'none'};
  }
`;
